import { ServiceSessionUserEvent } from '@modules/ServiceModule';
import { InboxContext } from '../types';

function handleSessionRecoveryCompleted(
  context: InboxContext,
  event: ServiceSessionUserEvent,
) {
  if (context.userId !== event.userId) {
    return;
  }
  // nothing to do here
}

export default handleSessionRecoveryCompleted;
